import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.css']
})
export class ManualComponent implements OnInit {

  local:string;
  url:string;
  urlSafe: SafeResourceUrl;
  id_pais:string;

  constructor(public sanitizer: DomSanitizer) { }
  ngOnInit(): void {
    this.id_pais=localStorage.getItem("id_pais");
    if(this.id_pais=='593'){
      this.url="http://62.171.172.148:8111/arbolArchivo/?ruta=/ecuador/manuales";
      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
      }else{
        this.url="http://62.171.172.148:8111/arbolArchivo/?ruta=/panama/manuales";
        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
           
      }
  }


 

}
